import { Col } from "react-bootstrap";

export const ProjectCard = ({
  title,
  description,
  imgUrl,
  projecturl,
  technologies = [],
}) => {

  return (
     <Col sm={6} md={4}>
      <div className="proj-imgbx">

        <img
          src={imgUrl}
          alt={`${title} project`}
          loading="lazy"
          decoding="async"
          className="project-image"
        />
        <a
          href={projecturl}
          target="_blank"
          rel="noopener noreferrer"
          className="project-link"
          aria-label={`View ${title} project`}
        >
          <div className="proj-txtx">
            <h4>{title}</h4>

            <span>{description}</span>

            {technologies.length > 0 && (
              <div className="project-tech">
                {technologies.map((technology, index) => (
                  <span key={index}>{technology}</span>
                ))}
              </div>
            )}

            {/* <div className="project-view">
              View Project →
            </div> */}
          </div>
        </a>
      </div>
    </Col>
  );
};
